import { SelectOptions } from '@cbuild/controls';

export enum SiteVisitStatus {
  SCHEDULED = 1,
  VISITED = 2,
  NOT_VISITED = 3
}

export const SITE_VISIT_STATUS_OPTIONS: SelectOptions = [
  { label: 'Schedule', value: SiteVisitStatus.SCHEDULED },
  { label: 'Visited', value: SiteVisitStatus.VISITED },
  { label: 'Not Visited', value: SiteVisitStatus.NOT_VISITED }
];
